// extracted by mini-css-extract-plugin
module.exports = {"background":"Shimmer_background__1Zzx2","Shimmer":"Shimmer_Shimmer__2wSKJ","placeholder":"Shimmer_placeholder__299qq"};